import * as moment from 'moment';
// eslint-disable-next-line import/no-unassigned-import
import 'moment/locale/pt-br';

moment.locale('pt-br');

export const DATE_FORMATS = {
  DATE: 'DD/MM/YYYY',
  TIME: 'HH:mm',
  TIMES: 'HH:mm:ss',
  DATETIME: 'DD/MM/YYYY HH:mm',
  DATETIMES: 'DD/MM/YYYY HH:mm:ss',
  ANSI: 'YYYY-MM-DD HH:mm:ss.SSSS',
  ANSI_S: 'YYYY-MM-DD HH:mm:ss',
  ANSI_DATE: 'YYYY-MM-DD',
  MINUTES: 'mm:ss',
};

export const formatDate = (date) => {
  if (!date) return null;
  return moment(date, DATE_FORMATS.ANSI).format(DATE_FORMATS.DATE);
};

export const formatTime = (date) => {
  if (!date) return null;
  return moment(date, DATE_FORMATS.ANSI).format(DATE_FORMATS.TIME);
};

export const formatTimeS = (date) => {
  if (!date) return null;
  return moment(date, DATE_FORMATS.ANSI).format(DATE_FORMATS.TIMES);
};

export const formatDateTime = (date) => {
  if (!date) return null;
  return moment(date, DATE_FORMATS.ANSI).format(DATE_FORMATS.DATETIME);
};

export const formatDateTimeS = (date) => {
  if (!date) return null;
  return moment(date, DATE_FORMATS.ANSI).format(DATE_FORMATS.DATETIMES);
};

export const dateToAnsi = (date, format, formatAnsi = DATE_FORMATS.ANSI) => {
  if (!date) return null;
  return moment(date, format).format(formatAnsi);
};

export const ansiToDate = (date) => {
  if (!date) return null;
  return moment(date, DATE_FORMATS.ANSI).toDate();
};

export const ansiToMoment = (date) => {
  if (!date) return null;
  return moment(date, DATE_FORMATS.ANSI);
};

export const momentToDate = (date) => {
  if (!date) return null;
  return moment(date).format(DATE_FORMATS.ANSI);
};

export const timeToMoment = (time) => {
  if (!time) return null;
  return moment(`0000-01-01 ${time}`, DATE_FORMATS.ANSI);
};

export const getMeses = () => {
  return moment.monthsShort();
};

export const getNomeMes = (month) => {
  return month[0].toUpperCase() + month.slice(1);
};

export const getMesAtual = () => {
  return moment().get('month');
};

export const getNomeMesAtual = () => {
  return getNomeMes(moment().format('MMMM'));
};

export const formatDateExtenso = (date, format = DATE_FORMATS.ANSI) => {
  if (!date) return null;

  const data = moment(date, format);
  const semHora = data.format('HH:mm') === '00:00';

  return semHora ? data.format('dddd, DD [de] MMMM [de] YYYY') : data.format('dddd, DD [de] MMMM [de] YYYY [às] HH:mm');
};

export const formaDateToNow = (date, format = DATE_FORMATS.ANSI) => {
  if (!date) return null;
  const data = moment(date, format);
  const semHora = data.format('HH:mm') === '00:00';

  if (data.isSame(moment(), 'day')) {
    return semHora ? 'Hoje' : data.format('HH:mm');
  } else if (data.isSame(moment().subtract(1, 'day'), 'day')) {
    return semHora ? 'Ontem' : data.format('[Ontem às] HH:mm');
  } else if (data.isSame(moment(), 'week')) {
    return semHora ? data.format('dddd') : data.format('dddd [às] HH:mm');
  } else {
    return semHora ? data.format('DD/MM/YYYY') : data.format('DD/MM/YYYY [às] HH:mm');
  }
};

export const fromNow = (date) => {
  return moment(date).fromNow();
};

export default moment;
